/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, InputText, Link, Select } from 'veloe-ds';
import './ondeReceber.scss';
import { ondeReceber } from '../../actions/pedidoActions';
import ScriptTag from 'react-script-tag';

import { APP_PAGES } from '../../routes';
import { ondeReceberAsync } from '../../actions/asyncActions';
import { veloeGraphQlApi } from '../../api/graphql/graphQLAPI';
import enderecoFCG from '../../mutations/endereco';
import planoFCG from '../../mutations/plano';
import CEP_QUERY from '../../queries/cep';
import CIDADES_QUERY from '../../queries/cidades';
import { withSnackbar } from 'notistack';
import CepInput from '../../Components/Form/CepInput/CepInput';
import { statesBr } from './statesBr';
import { modalInformativo } from '../../Components/Modais';
import { eventTrackBasic, eventTrackRoute } from '../../utils/pushDataLayer.js';

const OndeReceber = ({
  pedido,
  activeLoader,
  inactiveLoader,
  ondeReceber,
  history,
}) => {
  const {
    ondeUsar,
    dadosEndereco,
    cepSearched: pedidoCepSearched,
    codigoPromocional,
  } = pedido;
  const button = {
    status: true,
    label: 'Informe os dados para continuar',
  };
  const listaCodigosPromocionais = codigoPromocional.planos.opcoes;
  const [formButton, setFormButton] = useState(button);
  const [showAddress, setShowAddress] = useState(false);
  const [invalidCep, setInvalidCep] = useState(false);
  const [address, setAddress] = useState(dadosEndereco);
  const [modalExistente, setModalExistente] = useState(false);
  const [cepSearched, setCepSearched] = useState(pedidoCepSearched);
  const [errorMessage, setErrorMessage] = useState('');
  const [cidades, setCidades] = useState([]);
  const [cidadesDescricao, setCidadesDescricao] = useState([]);
  const proposta = JSON.parse(localStorage.getItem('proposta'));

  useEffect(() => {
    if (!proposta) {
      history.push(APP_PAGES.CADASTRO);
    }

    eventTrackRoute('onde-receber');

    if (address.cep) {
      changeCep(address.cep);
      if (address.estado) {
        buscarCidades(address.estado);
      }
    }
  }, []);

  const changeCep = async (event) => {
    let cep = event.replace('-', '');
    address['cep'] = cep;
    setAddress({ ...address });
    setFormButton({
      status: true,
      label: 'Informe os dados para continuar',
    });

    if (cep.length === 8) {
      setShowAddress(false);

      veloeGraphQlApi(CEP_QUERY, { cep })
        .then((data) => {
          if (data !== undefined) {
            setaDadosDoCep(data);
            setCepSearched(true);
            return true;
          } else {
            address['cidade'] = address.cidade ? address.cidade : '';
            address['estado'] = address.estado ? address.estado : '';
            address['bairro'] = address.bairro ? address.bairro : '';
            address['endereco'] = address.endereco ? address.endereco : '';
            address['cidadeId'] = address.cidadeId ? address.cidadeId : '';
            address['numero'] = address.numero ? address.numero : '';
            address['complemento'] = address.complemento
              ? address.complemento
              : '';
            setAddress({ ...address });
            setShowAddress(true);
            setInvalidCep(false);
            validaDadosEndereco();
            setCepSearched(false);
            return true;
          }
        })
        .catch((err) => {
          console.log(err);
          setInvalidCep(true);

          address.cidade = '';
          address.cidadeId = undefined;
          address.estado = '';
          address.bairro = '';
          address.endereco = '';
          address.numero = '';
          address.complemento = '';
          setAddress({ ...address });
          return false;
        });
    }

    setShowAddress(false);
    setInvalidCep(false);
  };

  const buscarCidades = (estado, cidade) => {
    veloeGraphQlApi(CIDADES_QUERY, { estado }).then((data) => {
      setCidades(data.cidades);
      let listaDescricao = [];

      data.cidades.map((cidade) => {
        listaDescricao.push(cidade.descricao);
      });
      setCidadesDescricao(listaDescricao);
      setCidadeId(cidade, data.cidades);
    });
  };

  const setaDadosDoCep = (result) => {
    if (result.erro) {
      setShowAddress(false);
      setInvalidCep(true);
    } else {
      address['cidade'] = result.cep.cidade || '';
      address['estado'] = result.cep.uf || '';
      address['bairro'] = result.cep.bairro || '';
      address['endereco'] = result.cep.logradouro || '';
      buscarCidades(result.cep.uf, result.cep.cidade);
      if (!address.numero) {
        address['numero'] = '';
      }
      if (!address.complemento) {
        address['complemento'] = '';
      }
      setAddress({ ...address });
      setShowAddress(true);
      setInvalidCep(false);
      validaDadosEndereco();
    }
  };

  const changeNumber = (event) => {
    saveInputForm(event, 'numero');
    validaDadosEndereco();
  };

  const changeComplement = (event) => {
    saveInputForm(event, 'complemento');
  };

  const setCidadeId = (cidadeDescricao, cidadeList) => {
    if (cidades.length > 0) {
      cidadeList = cidades;
    }
    cidadeList.map((cidade) => {
      if (cidade.descricao === cidadeDescricao) {
        address['cidadeId'] = cidade.id;
        setAddress(address);
        clearInterval();
      }
    });
    validaDadosEndereco();
  };

  const saveInputForm = (event, key) => {
    address[key] = event;
    if (key === 'cidade' && cidades) {
      setCidadeId(event);
    }
    if (key === 'estado') {
      address.cidade = '';
      buscarCidades(event);
    }
    setAddress({ ...address });
    validaDadosEndereco();
  };

  const verifyNumber = () => {
    return address.numero.length !== 0;
  };

  const validaDadosEndereco = () => {
    const formularioValido =
      address.cep.length &&
      address.cidade.length &&
      address.estado.length &&
      address.bairro.length &&
      address.endereco.length &&
      address.numero.length &&
      address.cidadeId;

    if (!formularioValido) {
      return setFormButton({
        status: true,
        label: 'Informe os dados para continuar',
      });
    }
    setFormButton({ status: false, label: 'Continuar' });
  };

  const chamaFuncRand = async () => {
    eventTrackBasic('clique:botao', 'continuar-endereco');
    const { dados } = JSON.parse(localStorage.getItem('proposta'));
    const {
      cep,
      endereco,
      numero,
      complemento,
      bairro,
      estado,
      cidade,
      cidadeId,
    } = address;
    const reCaptcha = await window.grecaptcha.execute(
      process.env.REACT_APP_KEY_RECAPTCHA,
      {
        action: 'homepage',
      },
    );

    const cidadeIdInt = parseInt(cidadeId);
    activeLoader();
    veloeGraphQlApi(enderecoFCG, {
      idProposta: dados.id,
      cep,
      logradouro: endereco,
      numero,
      complemento,
      bairro,
      uf: estado,
      cidade,
      cidadeId: cidadeIdInt,
      captchaResponse: reCaptcha,
    })
      .then((data) => {
        const ondeUsarId = ondeUsar.id;
        const { dados, validatorResponse } = data['enderecoFCG'];
        const proposta = JSON.parse(localStorage.getItem('proposta'));
        if (dados) {
          localStorage.setItem(
            'proposta',
            JSON.stringify({
              ...proposta,
              ...data['enderecoFCG'],
            }),
          );

          inactiveLoader();
          const sub = JSON.parse(localStorage.getItem('propostaSub'));
          const listaCompleta = listaCodigosPromocionais.find(
            (obj) => obj.subProdutoId === proposta.subProdutoId,
          );

          const {
            valorTarifa: valor,
            idProduto: produtoId,
            tipoPlano,
            codigoPromocional,
          } = listaCompleta;

          if (sub.dados.planoPos && proposta.subProdutoId === '002') {
            history.push(APP_PAGES.TIPO_PAGAMENTO);
          } else {
            //checkoutOptionDefault();
            veloeGraphQlApi(planoFCG, {
              idProposta: proposta.dados.id,
              tipoPlano,
              produtoId,
              valor,
              codigoPromocional,
            })
              .then((data) => {
                const { dados, validatorResponse } = data['planoFCG'];
                if (!dados) {
                  const { errors } = validatorResponse;
                  return errors.map((error) => {
                    setErrorMessage(error.message);
                    setModalExistente(true);
                  });
                }
              })
              .catch((err) => {
                inactiveLoader();
                setErrorMessage(err.message);
                setModalExistente(true);
              });
            ondeUsarId === 'ped' ||
            ondeUsarId === 'est' ||
            ondeUsarId === 'ped-est-manual' ||
            sub.dados.planoPos === false
              ? history.push(APP_PAGES.RECARGA_AUTOMATICA)
              : history.push(APP_PAGES.REVISE_COMPRA);
          }
        } else {
          const { errors } = validatorResponse;
          inactiveLoader();
          return errors.map((error) => {
            setErrorMessage(error.message);
            setModalExistente(true);
          });
        }
      })
      .catch((err) => {
        inactiveLoader();
        setErrorMessage(err.message);
        setModalExistente(true);
      });

    ondeReceber(address);
  };

  return (
    <div className="containerComponent">
      <div className="containerText">
        <div className="containerLabel">
          <label className="areaTexto">
            {proposta.tagEmMaos
              ? 'Preencha os dados do seu endereço'
              : 'Onde quer receber seu produto?'}
          </label>
        </div>
      </div>
      <div className="containerArea">
        <div className="containerOndeReceber">
          <CepInput
            label="Informe o CEP"
            id="cep"
            onChange={(event) => changeCep(event.target.value)}
            value={address.cep}
            tooltip={showAddress}
            isValid={invalidCep}
            onFocus={() => eventTrackBasic('interacao:campo', 'cep')}
            errorMessage="CEP não encontrado. Por favor, verifique e digite novamente."
          />

          <div className="labelNaoSeiCEP">
            <Link
              onBg="light"
              href="https://buscacepinter.correios.com.br/app/endereco/index.php"
              target="_blank"
              id="nao-sei-cep"
            >
              Não sei meu CEP
            </Link>
          </div>
          {showAddress && (
            <div className="containerInputCEP">
              <div className="containerInputCEP2">
                <Select
                  disabled={cepSearched}
                  label="Estado"
                  values={statesBr}
                  onBg="light"
                  id="uf"
                  onChange={(event) => {
                    eventTrackBasic('interacao:campo', 'estado');
                    saveInputForm(event, 'estado');
                  }}
                  value={address.estado}
                />
                <Select
                  disabled={cepSearched}
                  label="Cidade"
                  id="localidade"
                  values={cidadesDescricao}
                  onChange={(event) => {
                    eventTrackBasic('interacao:campo', 'cidade');
                    saveInputForm(event, 'cidade');
                  }}
                  value={address.cidade}
                />
              </div>
              <div className="containerInput1x">
                <InputText
                  label="Bairro"
                  onBg="light"
                  id="bairro"
                  onChange={(event) => {
                    eventTrackBasic('interacao:campo', 'bairro');
                    saveInputForm(event, 'bairro');
                  }}
                  value={address.bairro}
                />
              </div>
              <div className="containerInputCEP2">
                <InputText
                  label="Endereço"
                  onBg="light"
                  id="logradouro"
                  onChange={(event) => {
                    eventTrackBasic('interacao:campo', 'endereco');
                    saveInputForm(event, 'endereco');
                  }}
                  value={address.endereco}
                />
                <InputText
                  errorMessage="Digite um número válido."
                  isValid={verifyNumber}
                  onBg="light"
                  id="numero"
                  label="Número"
                  value={address.numero}
                  updateOnBlur={true}
                  updateOnChange={false}
                  onChange={(event) => changeNumber(event)}
                  onFocus={() => eventTrackBasic('interacao:campo', 'numero')}
                  onBlur={(event) => changeNumber(event)}
                />
              </div>
              <div className="containerInput1x">
                <InputText
                  inputProps={{
                    maxLength: 500,
                  }}
                  label="Complemento"
                  onBg="light"
                  id="complemento"
                  onChange={(event) => changeComplement(event)}
                  onFocus={() =>
                    eventTrackBasic('interacao:campo', 'complemento')
                  }
                  value={address.complemento}
                />
              </div>
            </div>
          )}
          <div className="stack-button-container" />
          <Button
            className="stack-button-full"
            {...{
              onBg: 'light',
              color: 'primary',
              disabled: formButton.status,
              label: formButton.label,
              id: 'btn-continuar',
            }}
            onClick={chamaFuncRand}
          />
          {modalExistente &&
            modalInformativo(
              true,
              () => {
                setModalExistente(false);
              },
              'Ops!',
              errorMessage,
            )}
        </div>
      </div>
      <ScriptTag
        type="text/javascript"
        src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`}
      />
    </div>
  );
};

const mapStateToProps = ({ pedido }) => {
  return { pedido };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ondeReceber: (onde) => dispatch(ondeReceber(onde)),
    ondeReceberAsync: (onde) => dispatch(ondeReceberAsync(onde)),
    activeLoader: () => dispatch({ type: 'loader_active' }),
    inactiveLoader: () => dispatch({ type: 'loader_inactive' }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(OndeReceber));
